// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"c58092c3","467":"9bb537e0"}[chunkId] + ".chunk.css";
};